import { Component, computed, input, InputSignal, output, Signal, ChangeDetectionStrategy } from '@angular/core';
import { Log } from '../../models/log';
import { Psychologist } from '../../models/psychologists';
import { TranslatePipe } from '@ngx-translate/core';
import { UsersSharingLogsComponent } from '../users-sharing-logs/users-sharing-logs.component';
import { LoadingComponent } from '../loading/loading.component';
import TYPES from '../../constants/types';

@Component({
  selector: 'app-streak',
  imports: [
    TranslatePipe,
    UsersSharingLogsComponent,
    LoadingComponent
  ],
  templateUrl: './streak.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './streak.component.scss'
})
export class StreakComponent {

  yourMindLogIsActive:InputSignal<boolean> = input<boolean>(true);
  sharedWithYouIsActive:InputSignal<boolean> = input<boolean>(false);
  listLogs: InputSignal<Log[] | undefined> = input();
  listCompleted: Signal<any[]> = computed(() => {
    const listSize = this.listLogs()?.length ?? 0;
    let arrayAux = []; 
    if(listSize < 30){
      arrayAux = new Array(30 - listSize).fill(null);      
    }
    return [...(this.listLogs() ?? []), ...arrayAux];
  });
  listShared: InputSignal<any[] | undefined> = input();
  listSharedCompleted: Signal<any[]> = computed(() => {
    const listSize = this.listShared()?.length ?? 0;
    let arrayAux = []; 
    if(listSize < 30){
      arrayAux = new Array(30 - listSize).fill(null);      
    }
    return [...(this.listShared() ?? []), ...arrayAux];
  });
  psychologist: InputSignal<Psychologist | undefined> = input();
  loadingLogs: InputSignal<boolean> = input(false);
  loadingSharedLogs: InputSignal<boolean> = input(false);
  filterBy: InputSignal<string> = input('');

  userSelected = output<string>();

  moods:any = TYPES.APPLICATION.MOODS;

  constructor(){}

  getMoodColor(mood:string | null = ''){
    switch(mood){
      case 'moods.super_positive':{
        return 'super-positive';
      }
      case 'moods.positive':{
        return 'positive';
      }
      case 'moods.neutral':{
        return 'neutral';
      }
      case 'moods.negative':{
        return 'negative';
      }
      case 'moods.super_negative':{
        return 'super-negative';
      }
      default:{
        return '';
      }
    }
  }

  getMood(label:string|null){
    return this.moods.filter(
      (item:any) => {
        return item.label === label;
      }
    )[0];
  }

  filterByUser(userId:any){
    this.userSelected.emit(userId);
  }

}
